import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { formatTimelineAxisTick } from './format-timeline-axis-tick';

/**
 * Memoized `(visibleHours, tickValue, timeZone?) => label` formatter for the stream availability timeline axis, bound to the app's current locale.
 */
export function useFormatTimelineAxisTick() {
  const { locale } = useIntl();

  return useCallback(
    (visibleHours: number, tickValue: Date | number, timeZone?: string) =>
      formatTimelineAxisTick(locale, visibleHours, tickValue, timeZone),
    [locale],
  );
}
